<template>
  <base-modal
    hideFooter
    :size="'lg'"
    @hidden="$emit('onCloseModal')"
    @show="initCustomerForm"
  >
    <template #modal-title>
      <span class="customer-edit-modal-title">แก้ไขข้อมูลลูกค้า</span>
    </template>
    <b-form @submit.prevent="$emit('onSubmit')">
      <b-row class="p-3">
        <b-col cols="12" md="6">
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="$i18n.t('customerForm.name')"
                label-for="customer-name"
                class="required"
              >
                <b-form-input
                  id="customer-name"
                  required
                  v-model="customerForm.name"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$i18n.t('customerForm.mobile')"
                label-for="customer-phone"
                class="required"
              >
                <b-form-input
                  id="customer-phone"
                  required
                  v-model="customerForm.mobile"
                />
              </b-form-group>
            </b-col>
            <!-- <b-col cols="12">
              <b-form-group
                :label="$i18n.t('customerForm.lineId')"
                label-for="customer-line"
                class="required"
              >
                <b-form-input
                  id="customer-line"
                  required
                  v-model="customerForm.lineId"
                />
              </b-form-group>
            </b-col> -->
            <b-col cols="12">
              <b-form-group
                :label="$i18n.t('customerForm.email')"
                label-for="customer-email"
                class="required"
              >
                <b-form-input
                  id="customer-email"
                  required
                  v-model="customerForm.email"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group
                :label="$i18n.t('customerForm.birthDate')"
                label-for="customer-birthDate"
                class="required"
              >
                <b-form-datepicker
                  id="customer-birthDate"
                  :date-format-options="{
                    day: 'numeric',
                    year: 'numeric',
                    month: 'numeric',
                  }"
                  :locale="$i18n.locale"
                  v-model="customerForm.birthDate"
                ></b-form-datepicker>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" md="6">
          <div class="d-flex flex-wrap w-100 justify-content-center mt-2">
            <div :style="renderImageUrl" class="customer-profile" />
            <b-button variant="primary" class="mt-1 upload-button">
              <div
                class="d-flex align-items-center justify-content-center"
                @click="onUpload"
              >
                <component :is="'Camera'" class="upload-icon" />
                <span>Upload</span>
              </div>
            </b-button>
            <input
              ref="refInputEl"
              type="file"
              class="d-none"
              accept="image/*"
              @change="handleUploadChange"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center ">
          <b-button variant="success" class="mr-1" type="submit"
            >บันทึก</b-button
          >
          <b-button variant="outline-danger" @click="$emit('onCloseModal')"
            >ยกเลิก</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </base-modal>
</template>

<script>
  import {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BButton,
  } from 'bootstrap-vue';
  import BaseModal from '@core/components/base-modal/BaseModal.vue';
  import Camera from '@/@core/components/svg/common/Camera.vue';

  import useCustomerEditModal from '../hooks/useCustomerEditModal';

  export default {
    components: {
      BRow,
      BCol,
      BForm,
      BFormInput,
      BFormGroup,
      BaseModal,
      BFormDatepicker,
      BButton,
      Camera,
    },

    props: {
      customerDetail: Object,
    },

    setup(props) {
      const {
        customerForm,
        renderImageUrl,
        handleUploadChange,
        onUpload,
        initCustomerForm,
      } = useCustomerEditModal(props.customerDetail);

      return {
        customerForm,
        renderImageUrl,
        onUpload,
        handleUploadChange,
        initCustomerForm,
      };
    },
  };
</script>

<style></style>

<style scoped>
  @import '~@/assets/css/pages/data-management/customer-edit-modal.css';
</style>
